precision highp float;

uniform sampler2D uMap;
uniform float     uAlphaTest;
uniform float     uOpacity;
uniform vec3      uTint;
uniform float     uLogDepthBufFC;

in vec2  vUv;
in float vFade;
in float vSeed;
in float vFragDepth;

out vec4 fragColor;

void main() {
  // Per-instance horizontal mirror flip for variety — derived from the seed so
  // it's stable per instance. No cost: just a sign flip on UV.x.
  float mirror = step(0.5, fract(vSeed * 7.1));
  vec2 uvm = vec2(mix(vUv.x, 1.0 - vUv.x, mirror), vUv.y);

  vec4 tex = texture(uMap, uvm);

  // Distance-fade as a screen-space dither dissolve. Stochastic threshold per
  // fragment keeps the silhouette intact (vs scaling alpha, which would shrink
  // it). Dither is fine-grained noise; reads as stipple at the fade boundary
  // and is invisible at full opacity.
  float dither = fract(sin(dot(gl_FragCoord.xy, vec2(12.9898, 78.233))) * 43758.5453);
  if (vFade < dither) discard;

  // Texture alpha cutout.
  if (tex.a < uAlphaTest) discard;

  fragColor = vec4(tex.rgb * uTint, uOpacity);

  // Log depth — match the rest of the scene.
  gl_FragDepth = log2(vFragDepth) * uLogDepthBufFC * 0.5;
}
